import {Injectable} from '@angular/core';
import {LogoutStrategy} from './logout-strategy';
import {LogoutConfirmService} from '../logout-confirm.service';
import {environment} from '../../../../../../environments/environment';
import {switchMap, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DefaultLogoutStrategy implements LogoutStrategy {

  constructor(private readonly logoutConfirmService: LogoutConfirmService) {}

  execute(uuid: string): void {
    this.logoutConfirmService.deleteUserDetails(uuid).pipe(
      switchMap(() => this.logoutConfirmService.logout()),
      tap((res) => {
        localStorage.clear();
        window.open(
          `https://${res.userPoolDomainName}/logout?client_id=${res.clientID}&logout_uri=${environment.redirectUrl}`,
          '_self'
        );
      })
    ).subscribe();
  }
}
